import { defineMessages } from 'react-intl';

export default defineMessages({
    informationNotMatchRecord: {
        id: 'ml.quoteandbind.common.MLHVQDiscrepanciesCheckPopup.Some of the information provided does not match our records',
        defaultMessage: 'Some of the information provided does not match our records'
    },
    reviewAndSelectCorrectInfo: {
        id: 'ml.quoteandbind.common.MLHVQDiscrepanciesCheckPopup.Please review and select the correct information:',
        defaultMessage: 'Please review and select the correct information:'
    },
    continueWithQuote: {
        id: 'ml.quoteandbind.common.MLHVQDiscrepanciesCheckPopup.CONTINUE WITH QUOTE',
        defaultMessage: 'CONTINUE WITH QUOTE'
    },
    continueText: {
        id: 'ml.quoteandbind.common.MLHVQDiscrepanciesCheckPopup.There are additional items to review next',
        defaultMessage: 'There are {additionalItems} to review next'
    },
    additionalItems: {
        id: 'ml.quoteandbind.common.MLHVQDiscrepanciesCheckPopup.additional items',
        defaultMessage: 'additional items'
    },
    somethingWentWrong: {
        id: 'ml.quoteandbind.common.MLHVQDiscrepanciesCheckPopup.Something went wrong during this process.Please try again.',
        defaultMessage: 'Something went wrong during this process.  Please try again.'
    }
});
